import { User } from "@/swagger/models";
import { DateTime } from "luxon";
import Vue from "vue";

Vue.filter("time", (dateStringSql: string) => {
    // fromSQL doesn't handle "2021-05-05T10:36:08.527Z", which is what the API gives us
    // const t = DateTime.fromSQL(dateStringSql, { zone: "utc" }).toLocal();
    const t = DateTime.fromISO(dateStringSql, { zone: "utc" }).toLocal();
    return t.toLocaleString(DateTime.TIME_SIMPLE);
});

Vue.filter("date", (date: DateTime) => {
    // fromSQL doesn't handle "2021-05-05T10:36:08.527Z", which is what the API gives us
    // const d = typeof date === "string" ? DateTime.fromSQL(date) : date;
    const d = typeof date === "string" ? DateTime.fromISO(date) : date;
    return d.toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY);
});

Vue.filter("initials", (user: User) => {
    return `${user.firstName[0]}${user.lastName[0]}`.toUpperCase();
});

Vue.filter("name", (user: User) => {
    return `${user.firstName} ${user.lastName}`;
});
